import script from "./app.vue?vue&type=script&setup=true&lang=js"
export * from "./app.vue?vue&type=script&setup=true&lang=js"

import "./app.vue?vue&type=style&index=0&id=137322c8&lang=scss"

const __exports__ = script;

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import qInstall from "../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QHeader,QToolbar,QToolbarTitle,QSpace,QPageContainer,QFooter,QImg,QDrawer});
